import type { CityConfig } from "../city-template/types";

export const mindenConfig: CityConfig = {
  city: "Minden",
  state: "Nevada",
  stateAbbr: "NV",
  slug: "minden",
  route: "/cities/minden",
  title: "Emergency Passport Minden NV | Expedited Passport Renewal Carson Valley Douglas County | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport renewal in Minden, NV — 24-48 hour processing available. Fast passport services for Minden, Gardnerville, Genoa, and Douglas County travelers in the Carson Valley. A+ BBB rated, State Dept. registered courier. No agency visit required.",
  h1: "Emergency & Expedited Passport Services in Minden, NV",
  heroSubtitle: "Passport expiring before your trip from the Carson Valley? Fast Passport Center helps Minden, Gardnerville, Genoa, and Douglas County travelers get expedited passports in as little as 24 hours. No agency visit required — Nevada has no local passport agency.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Minden%20Nevada%20Carson%20Valley%20landscape%20with%20the%20dramatic%20Sierra%20Nevada%20mountain%20range%20as%20backdrop%2C%20green%20pastoral%20farmland%20and%20ranches%20in%20the%20valley%20floor%2C%20historic%20Minden%20downtown%20with%20charming%20western%20architecture%2C%20the%20Carson%20Valleys%20agricultural%20beauty%20with%20the%20towering%20eastern%20Sierra%20peaks%20in%20golden%20afternoon%20light%2C%20Minden%20Park%20and%20the%20stately%20Douglas%20County%20Courthouse%20visible%20in%20the%20scenic%20valley%20setting%2C%20no%20text%20or%20people%20visible&width=1800&height=700&seq=minden-nv-hero-001&orientation=landscape",
  heroImageAlt: "Minden Nevada Carson Valley landscape with Sierra Nevada mountain backdrop and pastoral farmland",
  geoPosition: "38.9541;-119.7657",
  geoPlacename: "Minden, Nevada",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "San Francisco Passport Agency",
    address: "95 Hawthorne St, Suite 600, San Francisco, CA 94105",
    distance: "Located in San Francisco — approximately 200 miles from Minden via US-395 and I-80",
  },
  nearbyCitiesZips: [
    { name: "Minden", zips: "89423" },
    { name: "Gardnerville", zips: "89410, 89460" },
    { name: "Genoa", zips: "89411" },
    { name: "Carson City", zips: "89701, 89706" },
    { name: "Stateline", zips: "89449" },
    { name: "South Lake Tahoe, CA", zips: "96150" },
    { name: "Zephyr Cove", zips: "89448" },
    { name: "Reno", zips: "89501" },
    { name: "Dayton", zips: "89403" },
    { name: "Yerington", zips: "89447" },
    { name: "Smith Valley", zips: "89430" },
    { name: "Topaz Lake", zips: "89410" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Minden and Carson Valley departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any UPS in Minden, Gardnerville, or Carson City" },
  ],
  internalLinks: [
    { name: "Emergency passport services in Carson City", route: "/cities/carson-city" },
    { name: "Fast passport renewal in Reno", route: "/cities/reno" },
    { name: "Expedited passport help in Gardnerville", route: "/cities/gardnerville" },
    { name: "Urgent passport services in Sacramento", route: "/cities/sacramento" },
    { name: "Same-day passport help in San Francisco", route: "/cities/san-francisco" },
    { name: "Passport courier services in Northern Nevada", route: "/states/nevada" },
  ],
  fpcOfficeAddress: "100 W Liberty St, Reno, NV 89501",
  fpcOfficeNote: "Fast Passport Center serves Minden remotely via secure overnight courier. We do not have a walk-in office in Minden — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Minden, Gardnerville, Genoa, and all of Douglas County.",
  fpcOfficeDistance: "Serving all of Minden, Gardnerville, Genoa, and the Carson Valley region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Minden and Douglas County. As the county seat nestled in the beautiful Carson Valley at the base of the Sierra Nevada, Minden serves a diverse community of ranchers, professionals, and Lake Tahoe-area residents. We provide fast passport processing for this scenic and historic region.",
  nearbyCitiesIntro: "We serve all Minden neighborhoods and Douglas County communities, including Gardnerville, Genoa, Stateline, Zephyr Cove, and the Lake Tahoe basin communities. We also serve Dayton, Yerington, Smith Valley, and Topaz Lake in the surrounding area. Our overnight shipping labels work from any UPS location in the Carson Valley.",
  howItWorksIntro: "Most Minden travelers complete everything online and ship documents overnight. No need to drive to Carson City, Reno, Sacramento, or San Francisco. Our emergency passport process delivers fast results for Carson Valley travelers.",
  mistakesIntro: "Minden and Douglas County residents enjoy a high quality of life in the Carson Valley, but passport processing requires navigating rural Nevada's limited government services. Here are the most common passport mistakes we see.",
  testimonialsIntro: "Minden, Gardnerville, and Carson Valley travelers trust us when their international departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Minden? Here are the most common ones we hear from Douglas County and Carson Valley travelers.",
  statePageRoute: "/states/nevada",
  statePageName: "Nevada",
  dmvWebsite: "https://dmv.nv.gov",
  dmvLabel: "Nevada DMV — Official Website",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth & Death Certificates", desc: "Order certified Nevada birth and death certificates from the Nevada Department of Health and Human Services — online, by mail, or in person at the Carson City office.", url: "https://dpbh.nv.gov/Programs/VitalRecords/Vital_Records/" },
    { icon: "ri-hearts-line", label: "Marriage Records", desc: "Request certified marriage certificates from the Douglas County Clerk in Minden. Located at the historic county courthouse on 8th Street.", url: "https://www.douglascountynv.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decrees", desc: "Obtain certified divorce records through the Douglas County District Court. Required for name change passport corrections.", url: "https://www.douglascountynv.gov/" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "If your record was issued outside Nevada, order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Nearest agency is San Francisco (200 miles via US-395/I-80)",
        "Requires crossing the Sierra Nevada",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Minden and Carson Valley travelers with immediate departure needs — as fast as 24 hours for urgent flights from Reno-Tahoe International.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance for Minden and Douglas County residents.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance — helpful for Carson Valley residents who travel between Nevada and California frequently.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Minden Nevada travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Minden NV and Douglas County." },
    { name: "New Passport", description: "First-time passport application assistance for Minden and Douglas County residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Margaret S.",
      location: "Minden, NV",
      rating: 5,
      text: "Douglas County professional with a business trip to London. Found out my passport had expired 4 days before. Fast Passport Center renewed it in 48 hours and I made my flight. Absolutely incredible.",
      service: "Emergency Passport",
    },
    {
      name: "The Thompson Family",
      location: "Gardnerville, NV",
      rating: 5,
      text: "Family trip to Italy planned for months but we forgot to check the kids' passports. Fast Passport Center processed all three in 4 days. The Carson Valley needs this kind of service.",
      service: "Child Passport",
    },
    {
      name: "Robert D.",
      location: "Genoa, NV",
      rating: 5,
      text: "Historic Genoa resident heading to a family reunion in Ireland. Needed a passport fast and the overnight courier from Minden worked flawlessly. New passport in 3 days.",
      service: "Passport Renewal",
    },
    {
      name: "Linda C.",
      location: "Topaz Lake, NV",
      rating: 5,
      text: "Living near Topaz Lake, I'm pretty far from any passport office. Fast Passport Center's overnight shipping system reached me out here and I had my passport in 4 days. Remarkable service for rural Douglas County.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "minden-1",
      name: "Minden Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1640 US-395 N",
      city: "Minden",
      state: "NV",
      zip: "89423",
      phone: "(775) 782-2422",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Minden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Minden facility. Passport acceptance by appointment. Call ahead to confirm availability.",
      icon: "ri-mail-line",
    },
    {
      id: "minden-2",
      name: "Douglas County Clerk — Minden",
      type: "County Clerk Passport Acceptance",
      address: "1616 8th St",
      city: "Minden",
      state: "NV",
      zip: "89423",
      phone: "(775) 782-9014",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Minden",
      website: "https://www.douglascountynv.gov/",
      websiteLabel: "Douglas County Clerk",
      notes: "County government passport acceptance. Serves all of Douglas County. Located at the historic county courthouse.",
      icon: "ri-government-line",
    },
    {
      id: "minden-3",
      name: "Gardnerville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1267 US-395 N",
      city: "Gardnerville",
      state: "NV",
      zip: "89410",
      phone: "(775) 782-2422",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "2 miles north of Minden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative facility serving Gardnerville. Minutes from Minden on US-395.",
      icon: "ri-mail-line",
    },
    {
      id: "minden-4",
      name: "Carson City Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1111 S Roop St",
      city: "Carson City",
      state: "NV",
      zip: "89701",
      phone: "(775) 884-2300",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles north of Minden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest facility near the Carson Valley. Full passport services with appointment. 15 miles north via US-395.",
      icon: "ri-mail-line",
    },
    {
      id: "minden-5",
      name: "South Lake Tahoe Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1046 Al Tahoe Blvd",
      city: "South Lake Tahoe",
      state: "CA",
      zip: "96150",
      phone: "(530) 541-2858",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles west of Minden via Kingsbury Grade",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Stateline and Lake Tahoe basin residents. 20 miles from Minden via scenic Kingsbury Grade.",
      icon: "ri-mail-line",
    },
    {
      id: "minden-6",
      name: "Reno Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "50 S Virginia St",
      city: "Reno",
      state: "NV",
      zip: "89501",
      phone: "(775) 788-0900",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "45 miles north of Minden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest passport facility in Northern Nevada. Full services. 45 miles via US-395.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 200 miles to San Francisco over Sierra", fpc: "No — ship from Minden or Gardnerville" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "The Carson Valley has quality photo options but not all meet State Department standards. Passport photos must be exactly 2×2 inches with a white or off-white background — avoid drugstore photo kiosks.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or wrong form type are the #1 reason for rejection at the Minden Post Office and Douglas County Clerk.",
    },
    {
      icon: "ri-cloud-windy-line",
      title: "Underestimating Sierra Nevada Mountain Travel",
      description: "Driving from Minden to the San Francisco Passport Agency means crossing the Sierra Nevada — which can be treacherous in winter. Kingsbury Grade closes during heavy snow. Our courier service eliminates this risk entirely.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel for Agency Appointment",
      description: "Without flight confirmation, the San Francisco regional agency will turn you away for emergency appointments — and you'll have driven 200 miles through the mountains for nothing.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. Douglas County families who travel between Nevada and California residences should ensure their documentation reflects their legal residence.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Nevada has no local passport agency. Standard processing takes 8–11 weeks. From the Carson Valley, mail transit through Carson City or Reno adds days — start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at the UPS Store in Minden or Gardnerville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Minden address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Minden, NV?",
      a: "Fast Passport Center offers emergency passport processing in Minden in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities. Nevada has no local passport agency — the nearest is San Francisco, 200 miles via US-395 and I-80 over the Sierra Nevada — so our courier service is by far the fastest and safest option for Carson Valley travelers.",
    },
    {
      q: "What is the nearest passport agency to Minden?",
      a: "The nearest passport agency to Minden is the San Francisco Passport Agency, approximately 200 miles away via US-395, I-80, and over the Sierra Nevada. In winter, mountain passes can close or require chains. Fast Passport Center's courier service means you never have to make that drive.",
    },
    {
      q: "Does Minden have a passport acceptance facility?",
      a: "Yes. The Minden Post Office at 1640 US-395 N and the Douglas County Clerk at 1616 8th St both offer passport acceptance services by appointment. The Gardnerville Post Office is also 2 miles north. For more comprehensive service, the Carson City Main Post Office is just 15 miles north via US-395.",
    },
    {
      q: "Do you serve the Lake Tahoe communities near Minden?",
      a: "Absolutely. Fast Passport Center serves the entire Carson Valley and Lake Tahoe basin, including Stateline, Zephyr Cove, and South Lake Tahoe. Whether you're a full-time resident or seasonal homeowner, our overnight courier system works throughout the region.",
    },
    {
      q: "What about Genoa — Nevada's oldest settlement?",
      a: "Genoa, just 7 miles from Minden, is Nevada's oldest town and we're proud to serve its residents. Our overnight shipping labels work from any location, and with no passport acceptance facility in Genoa itself, our courier service is especially valuable for this historic community.",
    },
    {
      q: "Can I fly internationally from near Minden?",
      a: "Reno-Tahoe International Airport is about 45 miles north of Minden via US-395 — about a 50-minute drive. Direct international flights to Mexico and connecting flights worldwide. Lake Tahoe Airport in South Lake Tahoe serves general aviation. Fast Passport Center ensures your passport is ready before departure.",
    },
    {
      q: "How much does expedited passport service cost in Minden?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by speed — emergency 24–48 hour, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your departure date and processing speed.",
    },
  ],
  photoLocations: [
    { name: "Minden Post Office", address: "1640 US-395 N, Minden, NV 89423", hours: "Mon–Fri: 9AM–4PM (photo by appointment)" },
    { name: "Walmart — Gardnerville", address: "1511 US-395 N, Gardnerville, NV 89410", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Raley's — Gardnerville", address: "1363 US-395 N, Gardnerville, NV 89410", hours: "Mon–Sun: 6AM–11PM" },
    { name: "UPS Store — Gardnerville", address: "1281 Kimmerling Rd, Gardnerville, NV 89460", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM" },
    { name: "CVS Pharmacy — Carson City", address: "1980 N Carson St, Carson City, NV 89701", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Carson City", address: "1400 N Carson St, Carson City, NV 89701", hours: "Mon–Sun: 7AM–10PM" },
    { name: "FedEx Office — Reno", address: "1201 Terminal Way, Reno, NV 89502", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "Costco — Carson City", address: "700 Old Clear Creek Rd, Carson City, NV 89705", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Nevada DMV — Carson City",
      address: "555 Wright Way, Carson City, NV 89711",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Closest DMV to Minden — about 15 miles via US-395. Primary Northern Nevada DMV. REAL ID processing. Online appointment recommended.",
      featured: true,
    },
    {
      name: "Nevada DMV — Reno",
      address: "555 Wright Way, Carson City, NV 89711",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service DMV. 45 miles from Minden via US-395. REAL ID available.",
      featured: true,
    },
    {
      name: "Douglas County Clerk — Minden",
      address: "1616 8th St, Minden, NV 89423",
      hours: "Mon–Fri: 8AM–5PM",
      note: "County government services for Douglas County residents. Located at the historic county courthouse. Passport acceptance available.",
      featured: false,
    },
    {
      name: "Nevada DMV — South Lake Tahoe Express",
      address: "1281 Kimmerling Rd, Gardnerville, NV 89460",
      hours: "Limited hours — call ahead",
      note: "Express DMV kiosk services in Gardnerville area. Limited services — call ahead for passport-related documentation.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RNO",
      name: "Reno-Tahoe International Airport",
      distance: "45 miles from Minden via US-395",
      address: "2001 E Plumb Ln, Reno, NV 89502",
      note: "Primary airport for Minden and the Carson Valley. Direct service to Mexico and connecting international flights. 45-mile drive via US-395.",
      flightUrl: "https://www.renoairport.com/",
      flightLabel: "Reno-Tahoe Airport",
      featured: true,
    },
    {
      code: "TVL",
      name: "Lake Tahoe Airport",
      distance: "15 miles from Minden via Kingsbury Grade",
      address: "1901 Airport Rd, South Lake Tahoe, CA 96150",
      note: "General aviation airport in South Lake Tahoe. Primarily serves private and charter flights — convenient for Lake Tahoe basin residents.",
      flightUrl: "https://www.cityofslt.us/",
      flightLabel: "Lake Tahoe Airport",
      featured: false,
    },
    {
      code: "SMF",
      name: "Sacramento International Airport",
      distance: "130 miles from Minden via US-50",
      address: "6900 Airport Blvd, Sacramento, CA 95837",
      note: "Alternative regional hub. Accessible via US-50 through South Lake Tahoe. Good option for west coast and transpacific connections.",
      flightUrl: "https://www.sacramento.aero/smf/",
      flightLabel: "Sacramento Airport",
      featured: false,
    },
  ],
};